import { SETTINGS_RESOURCES, SETTINGS_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: SETTINGS_RESOURCES.role,
						action: SETTINGS_SCOPES[SETTINGS_RESOURCES.role].updateRole,
						configPageName: PAGE_NAMES.settings
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: SETTINGS_RESOURCES.role,
						action: SETTINGS_SCOPES[SETTINGS_RESOURCES.role].createRole,
						configPageName: PAGE_NAMES.settings
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: SETTINGS_RESOURCES.role,
					action: SETTINGS_SCOPES[SETTINGS_RESOURCES.role].createRole,
					configPageName: PAGE_NAMES.settings
				});
			}
		}
	};
};

export default {
	makeActionList
};
